import { useEffect } from "react";
import { commitLocalUpdate, commitMutation, graphql } from "react-relay";

import { union } from "lodash";

import { useGroupEmitter } from "~/lib/websocket";
import { environment } from "~/models";

import type { beaconsSawBeaconMutation as MutationType } from "~/__generated__/beaconsSawBeaconMutation.graphql";

const sawBeaconMutation = graphql`
	mutation beaconsSawBeaconMutation($input: ViewerSawBeaconInput!) {
		viewerSawBeacon(input: $input) {
			viewer {
				unreadBeacons
			}
		}
	}
`;

type BeaconID =
	| "Navbar__1on1s"
	| "Navbar__personalStreams"
	| "Navbar__homepage"
	| "Navbar__feedback"
	| "Navbar__actionItems"
	| "Navbar__streamsSection";

export function sawBeacon(id: BeaconID) {
	return commitMutation<MutationType>(environment, {
		mutation: sawBeaconMutation,
		variables: {
			input: {
				beacon: id,
			},
		},
	});
}

/**
 * Given a user ID, subscribe to unreadBeacon updates over websocket, and update the Relay store
 * when updates happen.
 */
export function useBeaconSocket(userId: string) {
	const emitter = useGroupEmitter(`user.${userId.replace(/=/g, "")}`);

	useEffect(() => {
		function onMessage(payload: { type: string; data: { beacons: string[] } }) {
			if (payload.type === "UNREAD_BEACONS_ADDED") {
				commitLocalUpdate(environment, store => {
					const root = store.get("viewer");
					root?.setValue(union(root.getValue("unreadBeacons") as string[], payload.data.beacons), "unreadBeacons");
				});
			}
		}

		emitter.on("message", onMessage);
		return () => {
			emitter.off("message", onMessage);
		};
	}, [emitter]);
}
